/**
 * 파일명: ourHistory.js
 * 작성자: 김준형
 * 작성일자: 26.08.10
 * 설명: Landing - 주요 연혁 
 */
import React from "react";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { ReactComponent as ArrowIcon } from "asset/common/arrow-back.svg";
import style from "css/landing.module.css";

/*
  두 카드 모두 About Us로 이동
*/
const HISTORY_CARDS = [
  {
    title: "Company 연혁",
    desc: "리브테크놀로지의 설립부터 현재까지의 기업 성장 기록입니다.",
    img: "img/landing/history/company_history.png",
    img_m: "img/landing/history/company_bg_m.png",
    to: "about#company-history",
  },
  {
    title: "Solution 연혁",
    desc: "리브테크 독자 솔루션의 개발 및 고도화 기록입니다.",
    img: "img/landing/history/solution_history.png",
    img_m: null,
    to: "about#solution-history",
  },
];

function OurHistory() {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  return (
    <div className={style.history2_wrap}>
      <div className={style.history2_head}>
        <span className={style.history2_badge}>Our History</span>
        <h2 className={style.history2_title}>주요 연혁</h2>
        <p className={style.history2_subtitle}>
          리브테크놀로지의 증명된 히스토리
        </p>
      </div>

      <div className={style.history2_card_list}>
        {HISTORY_CARDS.map((card) => (
          <Link
            className={style.history2_card}
            to={`${process.env.REACT_APP_CLIENT_URL}${card.to}`}
            key={card.title}
          >
            <img
              className={style.history2_card_img}
              src={`${process.env.REACT_APP_CLIENT_URL}${
                (isMobile && card.img_m) || card.img
              }`}
              alt=""
            />
            <div className={style.history2_card_head}>
              <div className={style.history2_card_title}>{card.title}</div>
              <div className={style.history2_card_desc}>{card.desc}</div>
              <span className={style.history2_card_btn}>
                <ArrowIcon />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default OurHistory;
